import { CreateDiarioObrasResponse } from "../../../data/daos/create/create_diario_obra";
import { ICreateDiarioObraEfetivoUseCase } from "../../../presentation/useCases/create/create_diario_obra_efetivo_use_case";
import { ICreatDiarioObraUseCase } from "../../../presentation/useCases/create/create_diario_obra_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// CreateDiarioObraEfetivoUseCase

export class CreateDiarioObraEfetivoUseCase implements ICreateDiarioObraEfetivoUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async createDiarioObraEfetivo(
    IdDiarioObras: number,
    IdCargo: number | null,
    Tipo: number | null,
    Categoria: number | null,
    Quantidade: number | null,
    Descricao: string | null,
    IdFornecedor: number | null,
    IdsFuncionarios: number[] | null,
  ): Promise<void> {
    await this.repository.createDiarioObraEfetivo(
      IdDiarioObras,
      IdCargo,
      Tipo,
      Categoria,
      Quantidade,
      Descricao,
      IdFornecedor,
      IdsFuncionarios
    );
  }
}
